import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import TextField from '@mui/material/TextField';
import useDebounce from '../../hooks/useDebounce';

const ActivitySearchField = ({
  onSearch,
  onClear,
  placeholderText,
  toggleLoading,
  clearSearch,
}) => {
  const [searchValue, setSearchValue] = useState('');
  const debouncedSearchValue = useDebounce(searchValue, 300);

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchValue(value);
    toggleLoading(true);
  };

  const handleClearClick = () => {
    setSearchValue('');
    onClear();
  };

  useEffect(() => {
    if (debouncedSearchValue.trim()) {
      onSearch(debouncedSearchValue);
    } else {
      onClear();
    }
  }, [debouncedSearchValue, onSearch, onClear]);

  useEffect(() => {
    if (clearSearch) {
      setSearchValue('');
    }
  }, [clearSearch]);

  return (
    <div className='contacts-search-field'>
      <TextField
        placeholder={placeholderText || 'Search...'}
        variant='outlined'
        value={searchValue}
        onChange={handleSearchChange}
        fullWidth
        className='el-input-search'
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position='end'>
              {searchValue && (
                <ClearIcon onClick={handleClearClick} style={{ cursor: 'pointer' }} />
              )}
            </InputAdornment>
          ),
        }}
      />
    </div>
  );
};

ActivitySearchField.propTypes = {
  onSearch: PropTypes.func,
  onClear: PropTypes.func,
  placeholderText: PropTypes.string,
  toggleLoading: PropTypes.func,
  clearSearch: PropTypes.bool,
};

export default ActivitySearchField;
